module.exports = __webpack_public_path__ + "b77cf4ae733730c058451132f80c5b12.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js!./src/client/res/images/logo.png
// module id = 728
// module chunks = 0